const comments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatar: '瓜',
    time: '2小时前',
    text: '这个榜单太及时了！每次刷新都能看到最新的八卦，已经成了我每日必刷的网站。那个顶流男星的事情我追了三天了，终于在这里看到了完整的时间线梳理。',
    likes: 1289,
  },
  {
    id: 2,
    name: '八卦雷达已开启',
    avatar: '探',
    time: '5小时前',
    text: '黑料大赛的投稿机制真的不错，上次我匿名爆料的某网红翻车事件居然真的上榜单了！审核团队效率也很高，从投稿到上架只用了不到一天，太专业了。',
    likes: 876,
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    avatar: '夜',
    time: '8小时前',
    text: '作为一个资深吃瓜群众，我对比过好几个同类网站，黑料大赛的热度算法确实是最靠谱的。不会刻意炒作，数据维度也很全面，推荐的专题内容质量都很高。',
    likes: 654,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              <i className="ri-chat-1-line"></i> 用户声音
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              网友辣评
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              来看看吃瓜网友们对黑料大赛的真实评价
            </p>
          </div>

          <div className="max-w-[800px] mx-auto space-y-4">
            {comments.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-100 rounded-xl p-5 md:p-6"
              >
                <div className="flex items-start gap-4">
                  {/* Avatar */}
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="font-heading text-sm text-primary-600 font-bold">
                      {comment.avatar}
                    </span>
                  </div>
                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="text-sm font-semibold text-foreground-900">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-500">{comment.time}</span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
                      {comment.text}
                    </p>
                    <div className="flex items-center gap-4">
                      <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-0 p-0">
                        <i className="ri-thumb-up-line"></i>
                        <span>{comment.likes}</span>
                      </button>
                      <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-0 p-0 whitespace-nowrap">
                        <i className="ri-chat-3-line"></i>
                        <span>回复</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}